import * as React from 'react';
import { Box, TextField, Typography, Alert, IconButton, Modal, Snackbar, Table, TableBody, TableCell, TableHead, TableRow, Card, CardContent, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, TableContainer, Chip, TablePagination, MenuItem, Select, Button } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid';
import { Cached, Visibility, Refresh, Close, SimCardDownload, Download, ForwardToInbox, Search } from '@mui/icons-material';
import axios from 'axios';
import { Location } from 'react-router-dom';
import { SelectChangeEvent } from '@mui/material';
import { expTokenProcessAndGenerate } from '../../ApiSevices/AuthApis';
import { createJobidForAfterFileUpload } from '../../ApiSevices/FileUploadApis';
import { fetchJob, viewJobActivityDetail, viewErrorForSelectedActivityName, retriggerTheFailedActivityStatusAgain, DeleteJob, DispatchJobId } from '../../ApiSevices/JobListingApis';
import { getbroker } from '../../ApiSevices/UserMasterApis';
import { GridTable } from '../../Sidebar/SidebarStyles';
import { decodeJwt, getStatusColor, handleDownload, baseUrl, UserRole } from '../ApiCommonService';
import { fetchQuoteCsrJob, getCSRJobInfoStatus, getFileByFileId, getFileInfoByJobIdQuoteCompare, getJobByIdQuoteCompare } from '../../ApiSevices/QuoteCompareAPI';


type Order = 'asc' | 'desc';
interface JobFileInfo {
    id: number;
    FileName: string;
    FileType: string;
    FileForId: any;
    Status: string;
    ToFileName: string;
    FileSize: string;
    IsCorrupted: boolean;
    IsConverted: boolean;
    IsScanned: boolean;
    IsMerged: boolean;
    IsPublished: boolean;
    JobId: string;
    CreatedOn: string;
    PublishedFilePath: any
    FileID: number;
}
interface TableProps {
    displaysidebar: boolean;
    location: Location;
    ComplianceFlag: number |undefined;
}
interface Filters {
    brokerName: string;
}
interface HeadCell {
    id: keyof Data;
    label: string;
    disableSort?: boolean;
}
interface Data {
    JobId: string;
    JobTypeId: any;
    ClientName: string;
    MacroFile: string;
    IsActive: boolean;
    CreatedOn: string;
    DispatchedOn: string;
    UploadedBy: string;
    TAT: any;
    Status: string;
    Actions: string;
    Dispatch: string;
    UploadDiscrepancy: string;
    Remarks: string;
}
interface JobStatus {
    Id: number;
    Name: string;
    IsActive: boolean;
}
interface Row {
    DispatchedOn: string;
    MatchScore: string;
    JobTypeId: any;
    LobCode: string;
    CreatedOn: any;
    UpdatedOn: any;
    Id: string;
    ClientName: string;
    JobId: string;
    JobOwner: string;
    MacroFile: string;
    Status: string;
    IsActive: boolean;
    document?: File | null;
    documentName?: string;
    CreatedBy?: any;
    TAT?: any;
    Actions?: string;
    Dispatch?: string;
    UploadDiscrepancy?: string;
    Remarks?: string;
    UploadedBy: any;
    UploadedOn: any;
    JobCode: string;
    JobStatusID: number;
    ID: number;
    BrokerID: number;
    StatusName: string;
}

interface State {
    rows: Row[];
    order: Order;
    orderBy: keyof Data;
    page: number;
    rowsPerPage: number;
    isDrawerOpen: boolean;
    selectedRow: Row | null;
    isEditing: boolean;
    selectedRowIds: GridRowId[];
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    loading: boolean;
    activities: any[];
    errorDetailsArray: any[];
    fileInfo: JobFileInfo[];
    Remarksinfo: any;
    getJobId: any;
    getChecklistName: any;
    isActivityDrawerOpen: boolean;
    isFileModelOpen: boolean;
    isErrorCardOpen: boolean;
    selectedErrorMessage: string;
    searchTerm: string;
    searchQuery: string;
    isDialogOpen: boolean;
    isDeleteDialogOpen: boolean;
    isReprocessFlow: boolean;
    isCreateActivityDialogOpen: boolean,
    selectedJobId: null;
    selectedJobIdforModel: null;
    selectedInstanceId: null;
    currentFileIndex: number;
    selectedFiles: File | null;
    selectedStatusFilter: string;
    totalCount: any;
    statusId: any;
    ActivestatusId: any;
    isReprocessDialogOpen: boolean;
    decodedTokenJson: undefined,
    userId: undefined,
    RoleId: undefined,
    BrokerId: any,
    SelectedJob: any,
    jobInfoStatus: any[];
    statusValueArray: Record<number, string>;
    jobs: any[];
    noJobsFound: boolean;
    filters: Filters;
    brokerId: number;
    brokerList: { Broker_ID: number; vchBrokerName: string }[];
    statusFilterAnchorEl: HTMLElement | null;
    // hasFileForDispatch: any;
    hasFileForDispatchChanged: any;
    openConfirmDialog: boolean;
    dispatchId: any;
    FromDate: any;
    ToDate: any;
    isMSuser: boolean;
}

function getComparator<T>(order: 'asc' | 'desc', orderBy: keyof T): (a: T, b: T) => number {
    return (a, b) => {
        const aValue = a[orderBy];
        const bValue = b[orderBy];

        if (aValue == null) return 1;
        if (bValue == null) return -1;

        const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        return order === 'desc' ? -comparison : comparison;
    };
}

class QcJobListingCSR extends React.Component<TableProps, State> {
    docTypeArray: Record<number, string> = { 1: "CT", 2: "PT", 3: "CTE", 4: "PTE", 5: "Acord Application", 6: "Carrier Quote", 7: "Proposal", 8: "Schedule", 9: "Binder" }
    docOrder: number[] = [1, 2, 3, 4, 7, 5, 6, 9, 8];
    queryParams = new URLSearchParams(window.location.search);
    brokerList: any;

    constructor(props: TableProps) {
        super(props);
        this.state = {
            rows: [],
            order: 'desc',
            orderBy: 'CreatedOn',
            isDrawerOpen: false,
            selectedRow: null,
            isEditing: false,
            selectedRowIds: [],
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
            loading: false,
            activities: [],
            errorDetailsArray: [],
            fileInfo: [],
            Remarksinfo: null,
            getJobId: null,
            getChecklistName: null,
            isActivityDrawerOpen: false,
            isFileModelOpen: false,
            isErrorCardOpen: false,
            selectedErrorMessage: "",
            searchTerm: '',
            searchQuery: '',
            isDialogOpen: false,
            isDeleteDialogOpen: false,
            isReprocessFlow: false,
            isCreateActivityDialogOpen: false,
            selectedJobId: null,
            selectedJobIdforModel: null,
            selectedInstanceId: null,
            currentFileIndex: 0,
            selectedFiles: null,
            statusFilterAnchorEl: null,
            selectedStatusFilter: '',
            totalCount: '',
            page: 0,
            rowsPerPage: 100,
            statusId: this.queryParams.get('statusId') || '0',
            ActivestatusId: '0',
            isReprocessDialogOpen: false,
            decodedTokenJson: undefined,
            userId: undefined,
            RoleId: undefined,
            BrokerId: null,
            SelectedJob: '',
            brokerId: 0,
            brokerList: [],
            // hasFileForDispatch: [],
            hasFileForDispatchChanged: [],
            openConfirmDialog: false,
            dispatchId: null,
            jobInfoStatus: [],
            jobs: [],
            noJobsFound: false,
            statusValueArray: {},
            filters: {
                brokerName: '',
            },
            FromDate: null,
            ToDate: null,
            isMSuser: false
        };
    }

    statusValueFilterArray: Record<string, number> = {
        "": 0,
        "Pending": 1,
        "InProgress": 2,
        "Success": 3,
        "Failed": 4,
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    handleCloseDialog = () => {
        this.setState({ isDialogOpen: false, selectedJobId: null, selectedInstanceId: null });
    };
    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false, SelectedJob: null, });
    };

    componentDidMount(): void {
        const queryParams = new URLSearchParams(window.location.search);
        const statusId = queryParams.get('statusId') || '0';

        const token = sessionStorage.getItem('token');
        if (token) {
            const decodedToken = decodeJwt(token);
            const isMsuser = decodedToken?.RoleId === UserRole.MSUser;
            if (decodedToken) {
                this.setState({
                    decodedTokenJson: decodedToken, userId: decodedToken.UserId, RoleId: decodedToken.RoleId, BrokerId: !isMsuser ? decodedToken.BrokerId : 0, statusId, ActivestatusId: statusId, isMSuser: isMsuser
                }, () => {
                    if (!isMsuser)
                        this.fetchJobs();
                    if (isMsuser)
                        this.fetchBrokers();
                });
            } else {
                console.warn("Token decoding failed or returned null");
            }
        }
        this.fetchJobInfoStatus();
    }

    fetchJobInfoStatus = async () => {
        try {
            const statusData = await getCSRJobInfoStatus();
            const statusMap: Record<number, string> = {};
            statusData?.forEach((item: { Id: number, Name: string }) => {
                statusMap[item.Id] = item.Name;
            });

            this.setState({
                jobInfoStatus: statusData || [],
                statusValueArray: statusMap,  // ← Dynamically built map
                statusId: statusData[0].Id
            });
        } catch (error) {
            console.error('Error fetching job info status:', error);
        }
    };

    fetchBrokers = async () => {
        this.setState({ loading: true });
        try {
            const brokerData = await getbroker();
            this.setState({ brokerList: brokerData || [] });
        } catch (error) {
            console.error('Error fetching brokers:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    fetchJobs = async () => {
        const { page, rowsPerPage, BrokerId, statusId, searchQuery, FromDate, ToDate } = this.state;
        let statusFilter: number | undefined = undefined;
        if (statusId !== undefined && statusId !== null && statusId !== '' && statusId !== '0') {
            const num = Number(statusId);
            if (!isNaN(num)) {
                statusFilter = num;
            }
        }
        this.setState({ loading: true });
        try {
            const response = await fetchQuoteCsrJob(
                page,
                rowsPerPage,
                BrokerId,
                statusFilter,
                FromDate,
                ToDate,
                searchQuery
            );

            let allJobs = response?.data || [];

            allJobs?.forEach((obj: any) => {
                if (![24, 26, 27]?.includes(obj?.Status)) {
                    obj.Status = 24;
                }
            })

            // const hasChecklistJobs = allJobs.filter((job: any) => job?.Checklist !== null && job?.Checklist !== '');

            if (response?.data?.length > 0) {
                this.setState({
                    rows: response.data,
                    totalCount: response.totalCount,
                    // hasFileForDispatch: hasChecklistJobs
                });
                this.showSnackbar('Jobs fetched successfully!', 'success');
            } else {
                this.setState({ rows: [], totalCount: 0 });

                if (statusFilter !== undefined) {
                    this.showSnackbar('No JobIds found for the selected status.', 'info');
                }
                else {
                    this.showSnackbar('No jobId found', 'info');
                }
            }
        } catch (error) {
            console.error('Error fetching jobs:', error);
            this.showSnackbar('Failed to fetch jobs.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleRequestSort = (_: React.MouseEvent<unknown>, property: keyof Data) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
    };

    handleChangePage = (_: unknown, newPage: number) => {
        this.setState({ page: newPage }, () => {
            this.fetchJobs(); // Will use the correct this.state.statusId
        });
    };

    handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
            this.fetchJobs(); // Same here
        });
    };


    handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const term = event.target?.value || '';
        const trimmedTerm = term.trim();

        this.setState({ searchTerm: trimmedTerm }, () => {
            if (trimmedTerm === '') {
                this.setState(
                    {
                        searchQuery: '',
                        selectedStatusFilter: '',
                        statusId: 0,
                        page: 0,
                    },
                    () => {
                        this.fetchJobs();
                    }
                );
            }
        });
    };

    handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const isEnter = event.key === 'Enter';
        const isSpace = event.key === ' ' || event.keyCode === 32;

        if (isEnter || isSpace) {
            event.preventDefault();
            this.handleSearchClick();
        }
    };

    handleSearchClick = async () => {
        const { brokerId, rowsPerPage, searchTerm, FromDate, ToDate } = this.state;
        const validRowsPerPage = rowsPerPage > 0 ? rowsPerPage : 100;

        this.setState({
            loading: true,
            searchQuery: searchTerm,
            selectedStatusFilter: '',
            statusId: this.state?.jobInfoStatus[0]?.Id,
            page: 0
        }, async () => {
            try {
                const searchResponse = await fetchQuoteCsrJob(
                    0,
                    validRowsPerPage,
                    this.state.BrokerId,
                    this.state.statusId,
                    FromDate,
                    ToDate,
                    this.state.searchQuery
                );

                const statusObj = searchResponse?.data;
                if (![24, 26, 27]?.includes(statusObj[0]?.Status)) {
                    statusObj[0].Status = 24;
                }

                this.setState({
                    rows: statusObj || [],
                    totalCount: searchResponse?.totalCount || 0,
                });
            } catch (error) {
                console.error('Error in searching jobs:', error);
                this.showSnackbar('Failed to search jobs.', 'error');
            } finally {
                this.setState({ loading: false });
            }
        });
    };



    handleViewClick = (id: any, jobId: any) => async () => {
        this.setState({ loading: true });

        try {
            const getDataForJobidActivityStatus = await viewJobActivityDetail(id);
            if (getDataForJobidActivityStatus && getDataForJobidActivityStatus?.Activities?.length > 0) {
                this.setState({
                    activities: getDataForJobidActivityStatus?.Activities || [],
                    isActivityDrawerOpen: true,
                    selectedJobIdforModel: id,
                    SelectedJob: jobId
                });
            }
        } catch (error) {
            this.setState({
                activities: [],
                isActivityDrawerOpen: true,
                selectedJobIdforModel: id,
                SelectedJob: jobId
            });

            console.error('Error fetching jobid activity details:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleOpenReprocessDialog = () => {
        const firstActivity = this.state.activities.find(
            act => act.Order === 1 || act.ActivityName === "JobFileProcess"
        );

        if (firstActivity) {
            this.setState({
                selectedInstanceId: firstActivity.InstanceID,
                isDialogOpen: true,
                isReprocessFlow: true,
            });
        } else {
            this.showSnackbar("No eligible activity found to reprocess", "warning");
        }
    };

    handleRefreshJobTable = () => async () => {
        this.setState({ isActivityDrawerOpen: false, SelectedJob: '', isErrorCardOpen: false })
        await new Promise(resolve => setTimeout(resolve, 1000));
        await this.fetchJobs();
    };

    renderActivityModel = () => {
        const { activities, isActivityDrawerOpen, SelectedJob, isErrorCardOpen, errorDetailsArray, selectedRowIds, isDialogOpen, currentFileIndex, isReprocessDialogOpen } = this.state;
        const data = this.state?.activities;
        const orderSet = data.sort((a, b) => a.Order - b.Order);

        const lastErrorIndex = errorDetailsArray?.length - 1;

        return (
            <Modal open={isActivityDrawerOpen} onClose={() => this.setState({ isActivityDrawerOpen: false, SelectedJob: '' })}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    height: 'auto',
                    maxHeight: '90%',
                    width: '80%',
                    overflow: 'auto',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    padding: '15px',
                    borderRadius: 2
                }}>

                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                Activity Details
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                                <Grid item>
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" sx={{ mr: 2 }}>
                                            Job Id: {this.state.SelectedJob}
                                        </Typography>
                                        <Tooltip title="Refresh Activities table">
                                            <Refresh
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "blue",
                                                    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                                                }}
                                                onClick={this.handleViewClick(this.state.selectedJobIdforModel, this.state.SelectedJob)}
                                            />
                                        </Tooltip>
                                    </Box>
                                </Grid>

                                <Grid item>
                                    <Box display="flex" gap={1}>
                                        <Tooltip title="Reprocess first activity">
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                size="small"
                                                sx={{
                                                    textTransform: "none",
                                                    fontWeight: "bold",
                                                    borderRadius: "8px",
                                                    height: '30px',
                                                    fontSize: "12px",
                                                }}
                                                onClick={this.handleOpenReprocessDialog}
                                                disabled={orderSet.length === 0}
                                            >
                                                Reprocess
                                            </Button>
                                        </Tooltip>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            sx={{
                                                textTransform: "none",
                                                fontWeight: "bold",
                                                borderRadius: "8px",
                                                height: '30px',
                                            }}
                                            onClick={this.handleRefreshJobTable()}
                                        >
                                            Close
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>S.No</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Activity Name</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Created At</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Updated On</TableCell>
                                <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {orderSet.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" sx={{ fontSize: '12px' }}>
                                        No activities found for this Job ID.
                                    </TableCell>
                                </TableRow>
                            ) : (orderSet.map((activity, index) => (
                                <TableRow key={activity.InstanceID}>
                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>{activity?.ActivityName}</TableCell>
                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                        <Chip
                                            label={activity?.StatusID}
                                            sx={{
                                                backgroundColor: getStatusColor(activity?.StatusID).bg,
                                                color: getStatusColor(activity?.StatusID).text,
                                                fontWeight: "bold",
                                                fontSize: "10px",
                                                height: "20px",
                                                borderRadius: "20px",
                                                border: "none",
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>{new Date(activity.CreatedAt).toLocaleString()}</TableCell>
                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                        {(activity?.StatusID === "Failed" || activity?.StatusID === "Completed") &&
                                            new Date(activity?.Updatedon).toLocaleString("en-US", {
                                                month: "numeric",
                                                day: "numeric",
                                                year: "numeric",
                                                hour: "numeric",
                                                minute: "numeric",
                                                second: "numeric",
                                                hour12: true,
                                            })}
                                    </TableCell>

                                    <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                        {activity.StatusID === "Failed" && (
                                            <>
                                                <Tooltip title={`Click here to see the Error in ${activity.ActivityName}`}>
                                                    <Visibility
                                                        sx={{ cursor: "pointer", color: "red" }}
                                                        onClick={this.handleActivityErrorViewClick(activity.InstanceID)} />
                                                </Tooltip>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <Tooltip title={`Click here to retry ${activity.ActivityName}`}>
                                                    <Cached
                                                        sx={{ cursor: "pointer", color: "red" }}
                                                        onClick={() => this.handleAlertDailogForRetrigger(activity.InstanceID)} />

                                                </Tooltip>
                                            </>

                                        )}
                                    </TableCell>
                                </TableRow>
                            )))}

                        </TableBody>
                    </Table>

                    {/* Create Activity Dialog */}
                    <Dialog
                        open={this.state.isCreateActivityDialogOpen}
                        onClose={() => this.setState({ isCreateActivityDialogOpen: false })}
                    >
                        <DialogTitle>Confirm Activity Creation</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to Create New Activity
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="primary"
                                variant="contained"
                                autoFocus
                                onClick={async () => {
                                    const { selectedJobIdforModel } = this.state;
                                    await this.handleReCreateJobid(selectedJobIdforModel);
                                    this.handleViewClick(selectedJobIdforModel, this.state.SelectedJob)();
                                    this.setState({ isCreateActivityDialogOpen: false });
                                }}
                            >
                                Yes
                            </Button>
                            <Button
                                onClick={() => this.setState({ isCreateActivityDialogOpen: false })}
                                color="secondary"
                                variant="outlined"
                            >
                                No
                            </Button>
                        </DialogActions>
                    </Dialog>


                    {/* Confirmation Dialog */}
                    <Dialog open={isDialogOpen} onClose={this.handleCloseDialog}>
                        <DialogTitle>Confirm Job Trigger</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to retrigger the selected process?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleConfirmationForRetrigger} color="primary" variant="contained" autoFocus>
                                Yes
                            </Button>
                            <Button onClick={this.handleCloseDialog} color="secondary" variant="outlined">
                                No
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {isErrorCardOpen && (
                        <Card sx={{ overflow: 'hidden', height: 'auto', margin: '5px 0px 5px 0px', position: "relative", p: 2, bgcolor: "#ffebee" }}>
                            <IconButton
                                onClick={() => this.setState({ isErrorCardOpen: false, currentFileIndex: 0 })}
                                sx={{ position: "absolute", right: 10, top: 10, boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}
                            >
                                <Close />
                            </IconButton>

                            <CardContent>
                                {errorDetailsArray?.length > 0 ? (
                                    <Box
                                        sx={{
                                            borderBottom: "1px solid #ddd",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="subtitle1">
                                            <b>Error</b>
                                        </Typography>
                                        <Typography color="error" variant="body2" sx={{ border: '1px solid #ddd', fontSize: '15px', fontWeight: 'bold' }}> ErrorDetails: {errorDetailsArray[lastErrorIndex]?.ErrorDetails}</Typography>
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No error information available.
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    )}
                </Box>
            </Modal>
        );
    };

    handleActivityErrorViewClick = (id: string) => async () => {
        this.setState({ loading: true });
        try {
            const getErrorMsgofSelectedActivity = await viewErrorForSelectedActivityName(id);
            if (getErrorMsgofSelectedActivity && getErrorMsgofSelectedActivity?.length > 0) {
                this.setState({
                    errorDetailsArray: getErrorMsgofSelectedActivity || [],
                    isErrorCardOpen: true,
                });
            }
        } catch (error) {
            this.showSnackbar("Failed to display the error_details ", 'error');
            console.error('Error fetching errordetails:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleAlertDailogForRetrigger = (InstanceID: any) => {
        this.setState((prevState) => ({
            isDialogOpen: true,
            selectedInstanceId: InstanceID,
            isReprocessFlow: false,
        }));
    };

    handleConfirmationForRetrigger = () => {
        const { selectedInstanceId, selectedJobIdforModel } = this.state;
        if (selectedInstanceId) {
            this.handleRetryProcessCall(selectedInstanceId, selectedJobIdforModel);
        }
        this.handleCloseDialog();
    };


    handleConfirmReprocess = async () => {
        const { activities, selectedJobIdforModel } = this.state;
        this.setState({ loading: true, isReprocessDialogOpen: false });

        try {
            const targetActivity = activities.find(
                activity => activity.Order === 1 || activity.ActivityName === "JobFileProcess"
            );

            if (targetActivity) {
                await this.handleRetryProcessCall(targetActivity.InstanceID, selectedJobIdforModel);
            } else {
                this.showSnackbar("No matching activity found to reprocess.", 'warning');
            }
        } catch (error) {
            console.error('Error during reprocess:', error);
            this.showSnackbar("Failed to reprocess the activity.", 'error');
        } finally {
            this.setState({ loading: false });
        }
    };


    handleRetryProcessCall = async (InstanceID: any, selectedJobIdforModel: any) => {
        this.setState({ loading: true });

        try {
            const retriggerCallforFailedActivity = await retriggerTheFailedActivityStatusAgain(InstanceID, selectedJobIdforModel);
            if (retriggerCallforFailedActivity?.status === 200) {
                this.showSnackbar('The job process triggered successfully, the table data get refreshing...', 'success');
                await new Promise(resolve => setTimeout(resolve, 1000));
                await this.handleViewClick(this.state.selectedJobIdforModel, this.state.SelectedJob)();
            }
        } catch (error) {
            console.error('Error in retry the jobs:', error);
            this.showSnackbar('Failed to retry the activity.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFileInfoClick = (id: number, TenantId: number, JobId: any) => async () => {
        this.setState({ loading: true });
        try {
            const fileRemarksResponse = await getJobByIdQuoteCompare(id, TenantId);
            const fileInfoResponse = await getFileInfoByJobIdQuoteCompare(id, TenantId);
            const updatedFileInfo = fileInfoResponse?.map((fileObj: any, index: any) => ({
                ...fileObj,
                rowId: index + 1
            })) || [];

            this.setState({
                getJobId: fileRemarksResponse?.JobId || "",
                getChecklistName: fileRemarksResponse?.Checklist || "",
                Remarksinfo: fileRemarksResponse?.Remarks || "",
                fileInfo: updatedFileInfo,
                isFileModelOpen: true,
                SelectedJob: JobId,
                BrokerId: TenantId
            });


        } catch (error) {
            this.showSnackbar("Failed to fetch fileInfo", 'error');
            console.error('Error fetching fileInfo:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleDeleteClick = (jobId: string) => async () => {
        this.setState({ loading: true });
        try {
            const deleteResponse = await DeleteJob(jobId);
            if (deleteResponse?.message) {
                this.showSnackbar(deleteResponse.message, 'success');
                await new Promise(resolve => setTimeout(resolve, 2000));
                await this.fetchJobs();
            }
        } catch (error) {
            this.showSnackbar("Failed to delete the job.", 'error');
            console.error('Error deleting job:', error);
        } finally {
            this.setState({ loading: false, isDeleteDialogOpen: false, SelectedJob: null });
        }
    };

    handleOpenConfirmDialog = (jobId: any) => {
        this.setState({ openConfirmDialog: true, dispatchId: jobId });
    };

    handleCloseConfirmDialog = () => {
        this.setState({ openConfirmDialog: false, dispatchId: null });
    };

    handleDispatchJobIdClick = (id: string) => async () => {
        this.setState({ loading: true });
        try {
            const dispatchMsgResponse = await DispatchJobId(id);
            if (dispatchMsgResponse) {
                this.showSnackbar(dispatchMsgResponse, 'success');
            }
        } catch (error) {
            this.showSnackbar("Failed to dispatch the selected_job", 'error');
            console.error('Error in dispatching job:', error);
        } finally {
            this.setState({ loading: false, openConfirmDialog: false, dispatchId: null });
        }
    };

    renderFileInfoDrawer = () => {
        const { fileInfo, isFileModelOpen, Remarksinfo, getJobId, getChecklistName } = this.state;

        const downloadQuoteFile = async (fileId: number, tenantId: number, name: string) => {
            try {
                const blobUrlForFile = await getFileByFileId(fileId, tenantId);
                if (blobUrlForFile) {
                    handleDownload(blobUrlForFile, name);
                    this.showSnackbar(`The selected file ${name} downloaded successfully!`, 'success');
                }
            } catch (error) {
                this.showSnackbar("There is an error in downloading the file", 'error');
                console.error('Error in downloading:', error);
            }
        };

        const GenrateChecklist_downloadFile = async (s3url: string, Filename: string) => {
            try {
                const token = sessionStorage.getItem('token');
                const Token = await expTokenProcessAndGenerate(token);
                const url = `${baseUrl}api/FileManager/DownloadFileByS3FileName?fileName=${encodeURIComponent(s3url)}`;

                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'accept': 'application/octet-stream',
                        'Authorization': `Bearer ${Token}`
                    }
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const fileName = `${Filename}`;
                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);

                    this.showSnackbar(`The selected ${Filename} downloaded successfully!`, 'success');
                } else {
                    throw new Error('Failed to download file: ' + response.statusText);
                }
            } catch (error) {
                console.error('Error in downloading:', error);
                this.showSnackbar("There is an error in downloading the file", 'error');
            }
        };

        return (
            <Modal
                open={isFileModelOpen}
                onClose={() => this.setState({ isFileModelOpen: false })}
                aria-labelledby="file-info-modal"
                aria-describedby="file-information-details"
            >

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    marginTop: '40px',
                    padding: '16px',
                    height: '100vh',
                    overflow: 'auto',
                }}>
                    <Card sx={{
                        width: '90%',
                        maxWidth: '1000px',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        borderRadius: '12px',
                        padding: '15px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#fff',
                    }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                                    <Grid item>
                                        <Box display="flex" alignItems="center">
                                            <Typography variant="h6" gutterBottom>
                                                <span style={{ color: '#ab9e9ed6' }}> View   </span>
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item>
                                        <Box display="flex" gap={1}>
                                            <IconButton onClick={() => this.setState({ isFileModelOpen: false })} className="close-button">
                                                <Close />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography >
                                    Job Id : {this.state.SelectedJob}
                                </Typography>
                            </Grid>
                        </Grid>

                        <CardContent className="card-section">
                            <Typography variant="h6" gutterBottom>Input Files</Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {["Sl No", "File Name", "Doc_fieldType", "File Size", "File Type", "Action"].map((head) => (
                                                <TableCell key={head}>{head}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fileInfo.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={6}>No Input Files Found</TableCell>
                                            </TableRow>
                                        ) : (
                                            [...fileInfo]
                                                .sort((a, b) => this.docOrder.indexOf(a?.FileForId) - this.docOrder.indexOf(b?.FileForId))
                                                .map((file, index) => (
                                                    <TableRow key={file?.id || index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{file?.FileName}</TableCell>
                                                        <TableCell>{this.docTypeArray[file?.FileForId]}</TableCell>
                                                        <TableCell>
                                                            {file?.FileSize
                                                                ? `${(Number(file?.FileSize) / (1024 * 1024)).toFixed(2)} MB`
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell>{`.${file?.FileType}`}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Download File">
                                                                <IconButton
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() =>
                                                                        downloadQuoteFile(file?.FileID, this.state.BrokerId, file?.FileName)
                                                                    }
                                                                >
                                                                    <Download fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>

                        <CardContent className="card-section1">
                            <Typography variant="h6" gutterBottom>Output Files</Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {["File Name", "Action"].map((head) => (
                                                <TableCell key={head}>{head}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* {(this.state.RoleId && ![UserRole.CSR, UserRole.BrokerAdmin]?.includes(this.state.RoleId) && getJobId) && (
                                            <TableRow>
                                                <TableCell>{getJobId}_discrepancy.xlsx</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => discrepancy_downloadFile(getJobId)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        )} */}

                                        {getChecklistName != "" ? (
                                            <TableRow>
                                                <TableCell>{getChecklistName}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Click to download the file">
                                                        <IconButton
                                                            color="primary"
                                                            className="output-file-download-btn"
                                                            onClick={() => GenrateChecklist_downloadFile(`Document/PolicyChecklist/${getJobId}/Output/${getChecklistName}`, getChecklistName)}
                                                        >
                                                            <Download />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>) : null}
                                        {this.state.RoleId === UserRole.CSR && getChecklistName === "" && (
                                            <TableRow>
                                                <TableCell sx={{ padding: '0px 0px', textAlign: 'center', paddingLeft: '150px' }}>No files to display</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>

                        {/* <CardContent className="card-section">
                            <Typography variant="h6">Remarks</Typography>
                            <Typography className="remarks-text">
                                {Remarksinfo?.length > 0 ? Remarksinfo : ''}
                            </Typography>
                        </CardContent> */}
                    </Card>
                </Box>
            </Modal>

        );
    };

    handleReCreateJobid = async (jobId: any) => {
        this.setState({ loading: true });

        try {
            const jobIdCreateRes = await createJobidForAfterFileUpload(jobId);
            if (jobIdCreateRes?.status === 200) {
                this.showSnackbar('The job trigged succesfully', 'success');
            }
        } catch (error) {
            console.error('Error in triggering the jobs:', error);
            this.showSnackbar('Failed to triggering the.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFileChange = async (event: any, JobId: string) => {
        const input = event?.target as HTMLInputElement;
        const selectedFile = input?.files?.[0];

        if (selectedFile?.name?.split('_')[0]?.trim() != JobId) {
            this.showSnackbar('Mismatch between download and upload job_ID', 'error');
            input.value = "";
            return;
        }

        if (selectedFile) {
            if (selectedFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                alert("Only .xlsx files are allowed. Please select a valid file.");
                input.value = "";
                return;
            }
            this.setState({ selectedFiles: selectedFile })
            await this.uploadCall(JobId, selectedFile);
        }

        input.value = "";
    };

    uploadCall = async (JobId: any, selectedFiles: any) => {
        this.setState({ loading: true });
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem("token"));
        const formData = new FormData();
        formData.append('file', selectedFiles);
        formData.append("jobid", JobId.toString());
        try {
            const response = await axios.post(`${baseUrl}api/Upload/UploadDiscrepencyExcel?job_id=${JobId}`, formData,
                {
                    headers: { Authorization: `Bearer ${Token}`, "Content-Type": "multipart/form-data" },
                }
            );
            if (response.status !== 200) {
                this.showSnackbar('Failed to upload the file', 'error');
                return "error";
            }
        }
        catch (error) {
            console.error('error', error);
        } finally {
            this.showSnackbar(`${JobId}_Discrepancy Uploaded successfully `, 'success');
            this.setState({ loading: false });
        }
    };

    handleStatusFilterClick = (event: React.MouseEvent<HTMLElement>) => {
        const url = new URL(window.location.href);
        const ActivestatusId = url.searchParams.get("statusId");
        this.setState({
            searchTerm: '',
            searchQuery: '',
            statusFilterAnchorEl: event.currentTarget,
            ActivestatusId
        });
    };


    handleStatusFilterClose = () => {
        this.setState({ statusFilterAnchorEl: null });
    };

    openDeleteDialog = (jobId: string) => {
        this.setState({ isDeleteDialogOpen: true, SelectedJob: jobId });
    };

    handleBrokerChange = (event: SelectChangeEvent<number>) => {
        const selectedBrokerId = parseInt(event.target.value as string, 10);

        this.setState({ brokerId: selectedBrokerId, page: 0 }, async () => {
            const { page, rowsPerPage, statusId, searchQuery } = this.state;
            const brokerFilter = selectedBrokerId === -1 ? undefined : selectedBrokerId;

            this.setState({ loading: true });

            try {
                const response = await fetchJob(
                    page,
                    rowsPerPage,
                    brokerFilter,
                    Number(statusId),
                    searchQuery,
                    true,
                    undefined,
                    this.props.ComplianceFlag || 0
                );

                if (response?.data?.length > 0) {
                    this.setState({
                        rows: response.data,
                        totalCount: response.totalCount,
                    });
                    this.showSnackbar('Jobs fetched successfully!', 'success');
                } else {
                    this.setState({ rows: [], totalCount: 0 });
                    this.showSnackbar('No data found for the selected broker.', 'info');
                }
            } catch (error) {
                console.error('Error fetching broker jobs:', error);
                this.showSnackbar('Failed to fetch jobs.', 'error');
            } finally {
                this.setState({ loading: false });
            }
        });
    };


    render() {
        const { rows, loading, order, orderBy, page, isDialogOpen, openConfirmDialog, rowsPerPage, snackbarOpen, snackbarMessage, snackbarSeverity, selectedStatusFilter, totalCount, statusValueArray, FromDate, ToDate, isMSuser } = this.state;
        const { displaysidebar } = this.props;
        const rowsWithSerialNumber = rows?.map((row, index) => {
            const createdDate = new Date(row.CreatedOn);
            const dispatchedOn = row.DispatchedOn ? new Date(row.DispatchedOn) : new Date();

            // Only compare by dates (ignore time)
            const createdDateOnly = new Date(createdDate.getFullYear(), createdDate.getMonth(), createdDate.getDate());
            const dispatchedDateOnly = new Date(dispatchedOn.getFullYear(), dispatchedOn.getMonth(), dispatchedOn.getDate());

            let tatDays = 0;

            // If created today => TAT = 0
            if (createdDateOnly.getTime() === new Date().setHours(0, 0, 0, 0)) {
                tatDays = 0;
            } else {
                const diffTime = dispatchedDateOnly.getTime() - createdDateOnly.getTime();
                tatDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            }

            return {
                ...row,
                sNo: page * rowsPerPage + index + 1,
                TAT: tatDays,
            };
        });
        const sortedRows = rowsWithSerialNumber?.filter((row: any) =>
            row?.JobCode?.toLowerCase()?.includes(this.state?.searchQuery.toLowerCase()) &&
            (selectedStatusFilter === '' || row?.Status === selectedStatusFilter)
        );

        const headCells: HeadCell[] = [
            { id: 'JobId', label: 'Job Id', disableSort: true },
            { id: 'Status', label: 'Status', disableSort: true },
            { id: 'ClientName', label: 'Client Name', disableSort: true },
            { id: 'CreatedOn', label: 'Uploaded On', disableSort: true },
            { id: 'UploadedBy', label: 'Uploaded By', disableSort: true },
            // { id: 'DispatchedOn', label: 'DispatchedOn', disableSort: true },
            // { id: 'TAT', label: 'TAT', disableSort: true },
            { id: 'Actions', label: 'Actions', disableSort: true },
            // { id: 'Remarks', label: 'Remarks', disableSort: true }
        ];

        const visibleRows = orderBy
            ? sortedRows.slice().sort(getComparator<Row>(order, orderBy))
            : sortedRows;

        const showNoJobsMessage = selectedStatusFilter !== '' && visibleRows.length === 0;
        const commonTextFieldSx = {
            "& .MuiOutlinedInput-root": { height: 30 },
            "& .MuiOutlinedInput-input": {
                padding: "4px 10px",
                fontSize: "0.875rem"
            }
        };

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div> {/* Your loader component or custom CSS */}
                    </Box>
                )}

                <GridTable displaysidebar={displaysidebar}>
                    <div>
                        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                            {/* Left side: Broker and Status */}
                            <Grid item>
                                <Box display="flex" gap={2} alignItems="center">
                                    {isMSuser &&
                                        <Box>
                                            <Typography
                                                variant="body2"
                                                sx={{ mb: 0.5, fontWeight: '500', }} // label text small
                                            >
                                                Select Broker
                                            </Typography>
                                            <Select
                                                size="small"
                                                value={this.state.BrokerId}
                                                onChange={(event) => {
                                                    const selectedStatusId = +event.target.value;
                                                    this.setState(
                                                        {
                                                            BrokerId: selectedStatusId,
                                                            page: 0,
                                                        },
                                                        this.fetchJobs
                                                    );
                                                }}
                                                displayEmpty
                                                sx={{ minWidth: 120, fontSize: '12px' }}
                                                renderValue={(selected) =>
                                                    Number(selected) === 0
                                                        ? 'Select Broker'
                                                        : this.state.brokerList?.find(
                                                            b => b.Broker_ID === Number(selected)
                                                        )?.vchBrokerName || ''
                                                }
                                            >
                                                {
                                                    this.state.brokerList?.map((status: any, idx: number) => (
                                                        <MenuItem
                                                            value={status.Broker_ID}
                                                            sx={{ fontSize: '12px' }}
                                                        >
                                                            {status?.vchBrokerName}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </Box>}

                                    {/* Status Dropdown */}
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{ mb: 0.5, fontWeight: '500', }} // label text small
                                        >
                                            Select Status
                                        </Typography>
                                        <Select
                                            size="small"
                                            value={this.state.statusId}
                                            onChange={(event) => {
                                                const selectedStatusId = event.target.value;
                                                this.setState(
                                                    {
                                                        statusId: selectedStatusId,
                                                        page: 0,
                                                    },
                                                    this.fetchJobs
                                                );
                                            }}
                                            displayEmpty
                                            sx={{ minWidth: 120, fontSize: '12px' }}
                                        >
                                            {
                                                this.state.jobInfoStatus?.map((status: any, idx: number) => (
                                                    <MenuItem
                                                        key={status?.OrderID ?? status?.Id ?? idx}
                                                        value={String(status?.OrderID ?? status?.Id ?? '')}
                                                        sx={{ fontSize: '12px' }}
                                                    >
                                                        {status?.Status ?? status?.Name ?? ''}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </Box>

                                    <Box>
                                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                            From Date
                                        </Typography>
                                        <TextField
                                            name="fromDate"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            size="small"
                                            value={FromDate}
                                            onChange={(e) => this.setState({ FromDate: e.target.value }, () => this.fetchJobs())}
                                            inputProps={{
                                            }}
                                            required
                                            sx={commonTextFieldSx}
                                        />
                                    </Box>

                                    <Box>
                                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                            To Date
                                        </Typography>
                                        <TextField
                                            name="fromDate"
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            size="small"
                                            value={ToDate}
                                            onChange={(e) => this.setState({ ToDate: e.target.value }, () => this.fetchJobs())}
                                            inputProps={{
                                            }}
                                            required
                                            sx={commonTextFieldSx}
                                        />
                                    </Box>

                                    <Box display="flex" alignItems="center" gap={0} sx={{ mt: 3 }}>
                                        {/* Search */}
                                        <TextField
                                            size="small"
                                            placeholder="Search by Job ID"
                                            value={this.state.searchTerm}
                                            onChange={this.handleSearchChange}
                                            onKeyDown={this.handleSearchKeyDown}
                                            sx={{
                                                '& .MuiInputBase-input::placeholder': { fontSize: '11px' },
                                                '& .MuiInputBase-input': { fontSize: '11px' },
                                                width: 180,
                                            }}
                                        />
                                        <Tooltip title="Click here for search result">
                                            <IconButton
                                                onClick={this.handleSearchClick}
                                                sx={{ mr: 1.5, height: '33px', border: '0.2px solid #d0bcbca1', borderRadius: '9%' }}
                                            >
                                                <Search fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Grid>

                            {/* Right side: Search + Refresh */}
                            <Grid item>
                                <Box display="flex" alignItems="center" gap={1}>
                                    {/* Refresh Icon */}
                                    <Box sx={{ marginTop: '26px' }}>
                                        <Tooltip title="Click here to refresh the table">
                                            <span>
                                                <Refresh
                                                    sx={{
                                                        cursor: 'pointer',
                                                        color: 'blue',
                                                        border: '0.1px solid black',
                                                        borderRadius: '4px',
                                                        padding: '3px',
                                                        height: 30,
                                                        width: 30,
                                                        mr: 1.5,
                                                        mt: 0.1,
                                                        boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 8px',
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            searchTerm: '',
                                                            searchQuery: '',
                                                            selectedStatusFilter: '',
                                                            statusId: this.state.jobInfoStatus[0].Id,
                                                            FromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split("T")[0],
                                                            ToDate: '',
                                                            brokerId: -1,
                                                            page: 0,
                                                            rowsPerPage: 100,
                                                        }, () => {
                                                            this.fetchJobs();
                                                        });
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #edebeb' }}>
                            <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
                                <TableContainer sx={{ minWidth: 'max-content' }}>
                                    <Table stickyHeader sx={{ height: '50px' }} size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: '11px', width: 30, fontWeight: 'bold' }}>S.No</TableCell>
                                                {headCells.map((headCell) => (

                                                    <TableCell
                                                        key={headCell.id}
                                                        sx={{
                                                            fontSize: '11px',
                                                            textAlign: "center",
                                                            fontWeight: 'bold',
                                                            width: headCell.id === 'JobId' ? 271 :
                                                                // headCell.id === 'JobTypeId' ? 190 :
                                                                headCell.id === 'Status' ? 230 :
                                                                    headCell.id === 'ClientName' ? 190 :
                                                                        // headCell.id === 'MacroFile' ? 190 :
                                                                        headCell.id === 'CreatedOn' ? 190 :
                                                                            headCell.id === 'UploadedBy' ? 190 :
                                                                                // headCell.id === 'DispatchedOn' ? 190 :
                                                                                // headCell.id === 'TAT' ? 130 :
                                                                                headCell.id === 'Actions' ? 190 :
                                                                                    headCell.id === 'Remarks' ? 190 : 190,
                                                            // minWidth: headCell.id === 'MacroFile' ? 190 : 190
                                                        }}
                                                    >
                                                        {headCell.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                    </Table>

                                    <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                        <Table size="small">
                                            <TableBody>
                                                {showNoJobsMessage ? (
                                                    <TableRow>
                                                        <TableCell colSpan={headCells.length + 3} align="center"
                                                            sx={{
                                                                fontSize: '14px',
                                                                fontWeight: 500,
                                                                color: 'gray',
                                                                padding: '20px',
                                                                borderBottom: 'none',
                                                            }}>
                                                            No JobIds found for the selected status.
                                                        </TableCell>
                                                    </TableRow>
                                                ) :
                                                    visibleRows?.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell colSpan={headCells.length + 3} align="center"
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: 500,
                                                                    color: 'gray',
                                                                    padding: '20px',
                                                                    borderBottom: 'none',
                                                                }}>
                                                                No records to display
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        visibleRows?.map((row, index) => {
                                                            const statusKey: any = row.JobStatusID;
                                                            const { bg, text } = getStatusColor(Number(statusKey));
                                                            const formatedDate = new Intl.DateTimeFormat('en-GB').format(new Date(row?.UploadedOn));
                                                            const formattedDispatchedOn = row.DispatchedOn ? new Intl.DateTimeFormat('en-GB').format(new Date(row.DispatchedOn)) : '';
                                                            return (
                                                                <TableRow hover key={row.Id}>
                                                                    <TableCell sx={{ fontSize: '11px', width: 60, }}>
                                                                        {page * rowsPerPage + index + 1}
                                                                    </TableCell>

                                                                    <TableCell
                                                                        sx={{
                                                                            fontSize: '11px',
                                                                            width: 271,
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        {row.JobCode}
                                                                    </TableCell>

                                                                    {/* <TableCell sx={{ fontSize: '11px', width: 190, textAlign: "center" }}>
                                                                        {(() => {
                                                                            const jobTypeMapping: Record<number, string> = {
                                                                                1: "AR",
                                                                                2: "MR",
                                                                            };
                                                                            return jobTypeMapping[row.JobTypeId] || "Unknown";
                                                                        })()}
                                                                    </TableCell> */}

                                                                    <TableCell sx={{ width: 230, textAlign: "center" }}>
                                                                        <Chip
                                                                            label={row.StatusName}
                                                                            size="small"
                                                                            sx={{
                                                                                backgroundColor: statusKey === 26 ? "#E5E7EB" : "#ECFDF5",
                                                                                color: statusKey === 26 ? "#111827" : "#047857",
                                                                                fontWeight: 500,
                                                                                fontSize: '11px',
                                                                                height: '22px',
                                                                                borderRadius: '20px',
                                                                                px: 1,
                                                                            }}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell sx={{ fontSize: '11px', width: 190, textAlign: "center" }}>
                                                                        {row.ClientName}
                                                                    </TableCell>

                                                                    {/* <TableCell sx={{ fontSize: '11px', width: 190, textAlign: "center" }}>
                                                                        {row.MacroFile}
                                                                    </TableCell> */}

                                                                    <TableCell sx={{ fontSize: '11px', width: 190, textAlign: "center" }}>
                                                                        {formatedDate}
                                                                    </TableCell>

                                                                    <TableCell sx={{ fontSize: '11px', width: 190, textAlign: "center" }}>
                                                                        {row.UploadedBy}
                                                                    </TableCell>

                                                                    {/* <TableCell sx={{ fontSize: '11px', width: 190, textAlign: "center" }}>
                                                                        {formattedDispatchedOn}
                                                                    </TableCell> */}

                                                                    {/* <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>
                                                                        {row.TAT}
                                                                    </TableCell> */}

                                                                    <TableCell sx={{ width: 190 }}>
                                                                        <Box sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            // paddingLeft: '20px',
                                                                        }}>
                                                                            <IconButton onClick={this.handleFileInfoClick(row.ID, row.BrokerID, row.JobCode)} size="small">
                                                                                <SimCardDownload fontSize="small" />
                                                                            </IconButton>
                                                                        </Box>
                                                                    </TableCell>

                                                                    {/* <TableCell sx={{
                                                                        fontSize: '11px',
                                                                        width: 190,
                                                                        maxWidth: 190,
                                                                        whiteSpace: 'normal',
                                                                        wordBreak: 'break-word',
                                                                        overflowWrap: 'break-word',
                                                                        textAlign: "center",
                                                                    }}>
                                                                        {row.Remarks}
                                                                    </TableCell> */}
                                                                </TableRow>
                                                            );
                                                        })
                                                    )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </TableContainer>
                            </Box>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                component="div"
                                count={totalCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </Paper>


                        <Dialog open={this.state.isDeleteDialogOpen} onClose={this.handleDeleteDialogClose}>
                            <DialogTitle>Confirm Delete Job</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to delete this job:{" "}
                                    <strong>{this.state.SelectedJob}</strong>?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={this.handleDeleteClick(this.state.SelectedJob)}
                                    color="primary"
                                    variant="contained"
                                    autoFocus
                                >
                                    Yes
                                </Button>
                                <Button onClick={this.handleDeleteDialogClose} color="secondary" variant="outlined">
                                    No
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Confirmation Dialog For Dispatch*/}
                        <Dialog open={openConfirmDialog} onClose={this.handleCloseConfirmDialog}>
                            <DialogContent sx={{
                                padding: '15px 15px',
                                paddingTop: '15px',
                                paddingBottom: '20px',
                                textAlign: 'center',
                            }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mb: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#E5E7EB',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <ForwardToInbox sx={{ color: '#111827', fontSize: 30 }} />
                                    </Box>
                                </Box>
                                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                    Dispatch!
                                </DialogTitle>
                                <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                    Are you sure want to dispatch the selected JobId?
                                </DialogContentText>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            px: 4,
                                            borderRadius: '6px',
                                        }}
                                        onClick={this.handleDispatchJobIdClick(this.state.dispatchId)}
                                    >
                                        Yes
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={this.handleCloseConfirmDialog}
                                        sx={{
                                            color: '#007bff',
                                            borderColor: '#007bff',
                                            px: 4,
                                            borderRadius: '6px',
                                            '&:hover': {
                                                borderColor: '#0056b3',
                                                color: '#0056b3',
                                            },
                                        }}
                                    >
                                        No
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Dialog>

                    </div>
                    {this.renderActivityModel()}
                    {this.renderFileInfoDrawer()}
                </GridTable >
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2500}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        );
    }
}

export default QcJobListingCSR;
